<template>
  <div class="mobile-container">
    <TopTitle/>
    <div class="user-info">
      <el-image
          :src="require('../resource/headPortrait.png')"
          fit="cover"
          :preview-src-list="[require('../resource/headPortrait.png')]"
          class="head-portrait"
          lazy>
        <template #error>
          <div class="image-fallback">
            <el-icon class="fallback-icon">
              <Fruits/>
            </el-icon>
            <span>图片加载失败</span>
          </div>
        </template>
      </el-image>
      <el-text size="large" class="font-bold-italic">
        <span class="font-bold-italic-text">苏菲和卡西法</span><br/><span class="font-bold-italic-integral">可用积分：225</span>
      </el-text>
    </div>
    <el-divider class="menu-divider"/>
    <div class="menu-info">
      <space direction="vertical" class="menu-font-bold">
        <img src="../resource/logistics.svg" class="menu-icon">
        <span class="fount-size">订单物流</span>
      </space>
      <el-divider class="menu-divider"/>
      <space direction="vertical" class="menu-font-bold">
        <img src="../resource/customerService.svg" class="menu-icon">
        <span class="fount-size">售后客服</span>
      </space>
      <el-divider class="menu-divider"/>
      <space direction="vertical" class="menu-font-bold">
        <img src="../resource/address.svg" class="menu-icon">
        <span class="fount-size">我的地址</span>
      </space>
      <el-divider class="menu-divider"/>
      <space direction="vertical" class="menu-font-bold">
        <img src="../resource/userAgreement.svg" class="menu-icon">
        <span class="fount-size">服务协议</span>
      </space>
    </div>
  </div>
</template>

<script>
import {onMounted} from 'vue';
import {ElDivider, ElText} from 'element-plus';
import 'element-plus/es/components/divider/style/css';
import 'element-plus/es/components/text/style/css';
import {Fruits} from "@element-plus/icons-vue";

export default {
  name: 'MyPage',
  components: {
    Fruits,
    ElDivider, // 注册分割线组件（核心）
    ElText     // 注册文本组件（确保el-text正常渲染）
  },
  setup() {
    // 组件挂载后的执行逻辑
    onMounted(() => {
      // user.value = JSON.parse(sessionStorage.getItem("loginUser"));
    });

    return {};
  },
};
</script>


<style scoped>
/* 基础样式 */
.mobile-container {
  height: 94vh;
  width: 100vw;
  overflow: hidden;
  position: fixed;
  /* 可选：优化滚动体验（iOS端） */
  -webkit-overflow-scrolling: touch;
  background-color: #F2F2E8; /* 黄色*/
  /*background-color: #33872B;*//* 绿色*/
  /*background-color: #EAF0E6;*/ /* 黄白色*/
  top: 0;
  left: 0;
}

/*昵称和头像*/
.user-info {
  display: flex;
  align-items: center; /* 垂直居中 */
  /*justify-content: center; !* 水平居中对齐 *!*/
  background-color: transparent; /* 绿色*/
  /* 圆角5px */
  border-radius: 5px;
  /* 外填充（外边距）2vh */
  margin-top: 2vh;
  margin-left: 2vw;
  margin-right: 2vw;
  /* 给个基础尺寸，可根据需求调整 */
  width: 96vw;
  height: 10%;

}

/*头像图片*/
.head-portrait {
  /* 圆角5px */
  border-radius: 50%;
  /* 外填充（外边距）10px */
  margin: 1%;
  float: left;
  width: 70px;
  height: 70px;
  object-fit: cover; /* 关键！图片裁剪填充正方形，不拉伸 */
}

/*用户昵称和积分的文字*/
.font-bold-italic {
  float: right;
  margin-left: 25px;
  margin-right: 1%;
  /*font-style: italic; *//* 斜体 */
}

/*用户昵称文字*/
.font-bold-italic-text{
  float: left;
  color: #000; /* 字体加黑（黑色） */
  font-weight: bold; /* 加粗 */
  font-size: 36px;
}

/*用户积分文字*/
.font-bold-italic-integral {
  float: left;
  color: #000; /* 字体加黑（黑色） */
  font-size: 20px;
  font-weight: bold; /* 加粗 */
  /*font-style: italic; *//* 斜体 */
}

/*菜单盒子*/
.menu-info {
  float: left;
  align-items: center; /* 垂直居中 */
  justify-content: left; /* 水平居中对齐 */
  background-color: transparent;
  /* 圆角5px */
  border-radius: 5px;
  border: 5px;
  gap: 10px; /* 子元素之间的间距 */
  /* 外填充（外边距）2vh */
  margin-left: 2vw;
  margin-right: 2vw;
  /* 给个基础尺寸，可根据需求调整 */
  width: 96vw;
  height: auto;

}

/*菜单文字*/
.fount-size {
  margin-top: 15px;
  margin-left: 37px;
  font-size: 24px;
}

/*菜单图标*/
.menu-icon {
  /* 圆角5px */
  border-radius: 5px;
  /* 外填充（外边距）10px */
  margin: 2%;
  float: left;
  width: 50px;
  height: 50px;
  object-fit: cover; /* 关键！图片裁剪填充正方形，不拉伸 */
}

/*菜单文字*/
.menu-font-bold {
  display: flex;
  justify-content: left; /*水平对齐*/
  color: #000; /* 字体加黑（黑色） */
  font-weight: bold; /* 加粗 */
  font-size: 26px;
  width: 100%;
  height: auto;
  /*font-style: italic; *//* 斜体 */
}

/*分割线*/
.menu-divider {
  margin-top: 1vh;
  margin-bottom: 1vh;
}

</style>